import { render } from "./WpeNumber.vue?vue&type=template&id=5b51aaec"
import script from "./WpeNumber.vue?vue&type=script&lang=js"
export * from "./WpeNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeNumber.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b51aaec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b51aaec', __exports__)) {
    api.reload('5b51aaec', __exports__)
  }
  
  module.hot.accept("./WpeNumber.vue?vue&type=template&id=5b51aaec", () => {
    api.rerender('5b51aaec', render)
  })

}


export default __exports__